import { call, put, takeLatest } from "redux-saga/effects";
import { loadMoreAddToCollectionModalCollectionsSuccess } from "./actions";
import { showAlert } from "../../actions";
import UserApi from "../../api/UserApi";
import api from "../../api/api";

function* handleLoadMoreAddToCollectionModalCollections({ userId, limit, pagingToken, selectedPost }) {
  const request = UserApi.getLoadUserCollectionsUrl({ userId, limit, pagingToken, postId: selectedPost });
  try {
    const { data: { data: collections, pagingToken: newPagingToken } } = yield call(
      api.get,
      request.url,
      request.config
    );
    yield put(loadMoreAddToCollectionModalCollectionsSuccess({ collections, limit, pagingToken: newPagingToken }));
  } catch (error) {
    yield put(showAlert("Sorry, Something wrong happened !", "error"));
  }
}

export function* watchAddToCollectionModalRequests() {
  yield takeLatest(
    "LOAD_MORE_ADD_TO_COLLECTION_MODAL_COLLECTIONS_REQUEST",
    handleLoadMoreAddToCollectionModalCollections
  );
}



// WEBPACK FOOTER //
// ./src/components/AddToCollectionModal/sagas.js